export default class SavProductChange extends HTMLSelectElement {
    constructor() {
        super();
    }

    connectedCallback() {
        $(this).on('change', function (e) {
            this.requestQuantities();
        });
    }

    requestQuantities() {
        let orderId = document.querySelector('select[name="order_id"]').value;
        let url = this.getAttribute('data-href');
        var productItemSelector = $(this);

        HegydCore.sendRequest(url, 'POST', {productId:this.value,orderId: orderId}, function (data) {
            if (data.hasOwnProperty('quantity')) {
                let quantityField = productItemSelector.parents('.product-item-block').find('.quantity-field');

                if(quantityField){
                    quantityField.attr('max',data.quantity);
                }else{
                    if (data.hasOwnProperty('errorMessage')) {
                        toastr.error(data.errorMessage);
                    }
                }

                $('#add-button-block').removeClass('d-none');
            }else{
                toastr.error(data.errorMessage);
            }

        },function (data) {
            if (data.hasOwnProperty('errorMessage')) {
                toastr.error(data.errorMessage);
            }
        });
    }
}